import { render, staticRenderFns } from "./NoResponseCounselingList.vue?vue&type=template&id=772efae4&scoped=true"
import script from "./NoResponseCounselingList.vue?vue&type=script&lang=js"
export * from "./NoResponseCounselingList.vue?vue&type=script&lang=js"
import style0 from "./NoResponseCounselingList.vue?vue&type=style&index=0&id=772efae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772efae4",
  null
  
)

export default component.exports